import React, { PropsWithChildren } from 'react';
import clsx from 'clsx';
import styles from './placeholder.module.scss';

interface Props {
  ready: boolean;
  wrapper?: any;
}

export function Placeholder(props: PropsWithChildren<Props>) {
  let Wrapper = props.wrapper;
  if (!Wrapper) {
    Wrapper = (props: PropsWithChildren<{ className: string }>) => (
      <span {...props} />
    );
  }

  const wrapperClassNames = clsx(!props.ready && styles.Placeholder);

  return <Wrapper className={wrapperClassNames}>{props.children}</Wrapper>;
}

export default Placeholder;
